import PropTypes from 'prop-types';

export const ProductLocationPropType = PropTypes.shape({
  warehouseId: PropTypes.number,
  warehouseName: PropTypes.string,
  isSelected: PropTypes.bool,
});
